var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useFormSchema)?_c('popup',{attrs:{"dialog-title":_vm.addDialogTitle || _vm.pageTitle,"dialog-action-button-label":"Save","dialog-action-func":_vm.saveNewRecord,"form-schema":_vm.useFormSchema,"dataSets":_vm.dataSets},model:{value:(_vm.useFormModel),callback:function ($$v) {_vm.useFormModel=$$v},expression:"useFormModel"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }